import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

export const useConferencesStore = defineStore('conferences', {
    state() {
        return {
            allConferences: [],
            singleConference: {},
            conferenceComments: [],
            conferencesTags: []
        }
    },
    actions: {
        async getConferences(
            start,
            end,
            searchString = '',
            tagsId = [],
            isDesc = true
        ) {
            const data = {
                start,
                end,
                search_string: searchString,
                tags_id: tagsId,
                is_desc: isDesc
            }

            this.allConferences = await helper.api(
                'GET',
                '/conferences_and_seminars',
                data
            )
        },

        async getSingleConference(conferenceId) {
            this.singleConference = await helper.api(
                'GET',
                `/conferences_and_seminars/${conferenceId}`,
                {}
            )
        },

        async getConferencesTags(hasSubTags) {
            const data = {
                with_tags: hasSubTags
            }

            this.conferencesTags = await helper.api(
                'GET',
                '/conferences_and_seminars/main_tag',
                data
            )
        },

        async incrementConferenceViews(conferenceId) {
            const data = {
                conference_seminar_id: conferenceId
            }

            await helper.api('PATCH', '/conferences_and_seminars', data)
        },

        async addComment(userId, conferenceId, commentText) {
            const data = {
                text: commentText,
                conference_seminar_id: conferenceId
            }

            await helper.api(
                'POST',
                `/conferences_and_seminars/comments?user_id=${userId}`,
                data
            )
        },

        async getComments(conferenceId, userId = null) {
            this.conferenceComments = await helper
                .api(
                    'GET',
                    `/conferences_and_seminars/comments/${conferenceId}`,
                    { user_id: userId }
                )
                .then((comments) => comments.reverse())
        },

        async deleteComments(userId, commentId) {
            const data = {
                user_id: userId,
                id: commentId
            }

            await helper.api(
                'DELETE',
                '/conferences_and_seminars/comments',
                data
            )
        },

        async updateComment(userId, commentId, commentText) {
            const data = {
                id: commentId,
                text: commentText
            }

            await helper.api(
                'PUT',
                `/conferences_and_seminars/comments?user_id=${userId}`,
                data
            )
        }
    },
    getters: {
        formatConferencesTags(state) {
            return (mainTagTitle, isSeminars) => {
                const result = []
                const data = state.conferencesTags.find(
                    (elem) => elem.name === mainTagTitle
                )

                if (data)
                    data.tags.sort(
                        (a, b) => new Date(b.year) - new Date(a.year)
                    )

                if (!isSeminars && data) {
                    for (const tag of data.tags) {
                        let flag = false

                        if (result.length === 0) {
                            result.push({
                                id: 1,
                                title: tag.name,
                                hasArchive: false,
                                filters: [
                                    {
                                        id: tag.id,
                                        title: tag.name + '-' + tag.year
                                    }
                                ]
                            })

                            continue
                        }

                        for (let i = 0; i < result.length; i++) {
                            if (result[i].title === tag.name) {
                                if (result[i].filters.length > 5) {
                                    if (!result[i].hasArchive) {
                                        result[i].filters.push({
                                            id: tag.id,
                                            title: `Архив ${tag.name}`,
                                            tagsId: [tag.id]
                                        })

                                        result[i].hasArchive = true
                                        flag = true
                                        break
                                    } else {
                                        result[i].filters[
                                            result[i].filters.length - 1
                                        ].tagsId.push(tag.id)
                                        flag = true
                                        break
                                    }
                                }

                                result[i].filters.push({
                                    id: tag.id,
                                    title: tag.name + '-' + tag.year
                                })
                                flag = true

                                break
                            }
                        }

                        if (flag) continue
                        else {
                            result.push({
                                id: result.length + 1,
                                title: tag.name,
                                hasArchive: false,
                                filters: [
                                    {
                                        id: tag.id,
                                        title: tag.name + '-' + tag.year
                                    }
                                ]
                            })
                        }
                    }
                } else {
                    let hasSeminarsTagsArchive = false
                    if (data) {
                        for (const tag of data.tags) {
                            if (result.length > 5) {
                                if (!hasSeminarsTagsArchive) {
                                    result.push({
                                        id: tag.id,
                                        title: 'Архив',
                                        tagsId: [tag.id]
                                    })

                                    hasSeminarsTagsArchive = true
                                    continue
                                } else {
                                    result[result.length - 1].tagsId.push(
                                        tag.id
                                    )
                                    continue
                                }
                            }

                            result.push({
                                id: tag.id,
                                title: tag.name + '-' + tag.year
                            })
                        }
                    }
                }

                return result
            }
        }
    }
})
